<template>
  <div>
    <div class='headline fontcolor mb-4'>Import Adoption Information</div>
    <v-card class="pl-7 pr-6 pt-5 pb-5" >
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      >
        <v-row>
          <v-col>
              <v-file-input
              accept=".csv"
              label='Upload CSV File*'
              persistent-hint
              hint="Allowed file format: .csv. File size should not be more than 10MB."
              v-model="chosenFile"
              :rules='[IsValidCSV]'
              @change="importCSVFile"
              >
              </v-file-input>
          </v-col>
        </v-row>
        <v-row v-if="getSampleDownloadFile" >
          <v-col class="ml-n2" >
            <AdminSampleDownloadButton :fileName='getSampleDownloadFile' :entityName='getSampleDownloadText' />
          </v-col>
        </v-row>
        <v-card-actions>
          <small color="primary">*indicates required fields</small>
          <v-spacer></v-spacer>
          <span
          v-if="readyForDownload"
          class="mr-4" >
            <v-btn v-if="logFileLink" target="_blank" :href='logFileLink' outlined class='fontcolor'>
              <v-icon dark>mdi-download</v-icon>View Log
            </v-btn>
          </span>
          <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
            <v-icon dark>mdi-upload</v-icon>Upload
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import ENV_CONSTANTS from './../../../../config/envVariables'
import CONSTANTS from './../../../../config/constant'
import AdminSampleDownloadButton from './../../sampledownloads/sampledownloadbutton'
export default {
  name: 'AdminAdoptionInformationImport',
  data: () => ({
    chosenFile: undefined,
    btnLoader: false,
    valid: true,
    readyForDownload: false,
    logFileLink: '',
    downloadLoader: false,
    sampleDownloadFile: ''
  }),
  components: {
    'AdminSampleDownloadButton': AdminSampleDownloadButton
  },
  mounted () {
  },
  computed: {
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    getSampleDownloadFile () {
      return CONSTANTS.SAMPLE_DOWNLOAD.IADI_PAGE.CODE_ADOPTION_DOWNLOAD_FILE
    },
    getSampleDownloadText () {
      return CONSTANTS.SAMPLE_DOWNLOAD.IADI_PAGE.CODE_ADOPTION_DOWNLOAD_TEXT
    }
  },
  methods: {
    IsValidFile () {
      return true
    },
    importCSVFile (e) {
      // reset viewlog button upon selecting new file for upload
      this.readyForDownload = false
      this.logFileLink = ''
      if (!this.chosenFile) {
        this.chosenFile = undefined
      }
      this.chosenFile = e
      return this.chosenFile
    },
    save () {
      if (this.$refs.form.validate() && typeof (this.chosenFile) !== 'undefined') {
        this.logFileLink = ''
        this.btnLoader = true
        let formData = new FormData()
        formData.append('importedFile', this.chosenFile)
        formData.append('userId', this.userId)
        formData.append('type', 'adoptionInfoCSV')
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/importICCAdoptionFile', { resolve, reject, formData })
        }).then((responseData) => {
          this.chosenFile = undefined
          this.btnLoader = false
          this.readyForDownload = true
          this.logFileLink = responseData.downloadUrl
          this.sampleDownloadFile = ''
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(responseData.responseMessage)
          this.$globalStates.notification.init_notifications = true
        }).catch((response) => {
          this.chosenFile = undefined
          this.btnLoader = false
          this.readyForDownload = false
          this.logFileLink = ''
          this.sampleDownloadFile = ''
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
      }
    },
    IsValidCSV (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'csv' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'CSV'
        ) {
          return 'Invalid file format. Only .csv file is allowed.'
        } else if (v.size / 1024 > ENV_CONSTANTS.MAXCSVFILESIZE) {
          return 'File size should not be more than 10MB.'
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>
